/**
 * usePermission — RBAC Option B frontend hook.
 *
 * Reads role flags from the existing AuthContext and resolves them against
 * the constants/mapping in `utils/permissions.ts`. Re-exports PERMISSIONS
 * for convenience so most call sites only need this one import.
 *
 * Treat the hook as a UX hint, not a security boundary. The backend
 * `apps/core/permissions.py` mirror is the actual gate.
 *
 * Usage:
 *   import { usePermission, PERMISSIONS } from '../../hooks/usePermission';
 *   const canViewPastPapers = usePermission(PERMISSIONS.VIEW_PAST_PAPER_QUESTIONS);
 *   {canViewPastPapers && <PastPaperBlock />}
 */

import { useAuth } from '../contexts/AuthContext';
import { hasPermission, PERMISSIONS, Permission } from '../utils/permissions';

export { PERMISSIONS };
export type { Permission };

export function usePermission(perm: Permission): boolean {
  const { isTeacher, isAdmin, isSchoolAdmin, isConsultant } = useAuth();
  return hasPermission(perm, { isTeacher, isAdmin, isSchoolAdmin, isConsultant });
}
